"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("../utils/utils");
function Selectable(opt) {
    if (opt === void 0) { opt = {}; }
    opt = Object.assign({
        onchange: function () { return 0; },
        className: '',
        elements: []
    }, opt);
    var onTap = _.on(opt.elements, 'click', function (evt) {
        opt.elements.forEach(function (e) {
            return e.classList[evt.target === e ? 'add' : 'remove'](opt.className);
        });
        opt.onchange(evt);
    });
    return {
        destroy: function () { return _.off.apply(_, onTap); }
    };
}
exports.default = Selectable;
